<template>
  <div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.bill_type') && isShowDimensions('bill_type') && enableCostConversion" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.bill_type')}}</div>
      <base-select
        :value="billType"
        :selectStyle="{maxWidth: '165px'}"
        :options="billTypeOpts"
        @change="billTypeChange"
        dropdownItemWordWrap
        :select-props="{ placeholder: $t('bill.text_49') }" />
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.brand') && isShowDimensions('brand')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.text_81')}}</div>
      <base-select
        v-model="formData.platform_brand"
        filterable
        :selectStyle="{maxWidth: '165px'}"
        :options="options.brand"
        @dropdownChange="v => dropdownChange('brand', v)"
        dropdownItemWordWrap
        :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.account') && isShowDimensions('account')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.text_60')}}</div>
      <base-select
        v-model="formData.account"
        filterable
        :selectStyle="{maxWidth: '165px'}"
        @dropdownChange="v => dropdownChange('account', v)"
        :options="options.account"
        dropdownItemWordWrap
        :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.linked') && isShowDimensions('linked_name')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.linked_account')}}</div>
      <base-select
        v-model="formData.linked_name"
        filterable
        :selectStyle="{maxWidth: '165px'}"
        @dropdownChange="v => dropdownChange('linked_name', v)"
        :options="options.linked_name"
        dropdownItemWordWrap
        :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.cloudprovider') && isShowDimensions('cloudprovider')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.text_311')}}</div>
      <base-select
        v-model="formData.cloudprovider"
        filterable
        :selectStyle="{maxWidth: '165px'}"
        @dropdownChange="v => dropdownChange('cloudprovider_name', v)"
        :options="options.cloudprovider_name"
        dropdownItemWordWrap
        :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.region') && isShowDimensions('region')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.text_83')}}</div>
      <base-select
        v-model="formData.region"
        filterable
        :selectStyle="{maxWidth: '165px'}"
        :options="options.region"
        @dropdownChange="v => dropdownChange('region', v)"
        dropdownItemWordWrap
        :select-props="{ placeholder: $t('bill.text_49'), dropdownMatchSelectWidth: false, mode: 'multiple' }" />
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.charge_type') && isShowDimensions('charge_type')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.text_84')}}</div>
      <base-select
        v-model="formData.charge_type"
        filterable
        id-key="item_id"
        name-key="item_name"
        :selectStyle="{maxWidth: '165px'}"
        :options="options.chargeType"
        :select-props="{ placeholder: $t('bill.text_49'), allowClear: true }" />
    </div>
    <div v-if="isAdminMode && !$isScopedPolicyMenuHidden('fee_hidden_items.domain') && isShowDimensions('domain')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.text_76')}}</div>
      <base-select
        v-model="formData.domain"
        filterable
        :selectStyle="{maxWidth: '165px'}"
        @dropdownChange="v => dropdownChange('domain', v)"
        :options="options.domain"
        dropdownItemWordWrap
        :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
    </div>
    <div v-if="(isAdminMode || isDomainMode) && !$isScopedPolicyMenuHidden('fee_hidden_items.project') && isShowDimensions('project')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.project')}}</div>
      <base-select
        v-model="formData.project"
        filterable
        :selectStyle="{maxWidth: '165px'}"
        :options="options.project"
        @dropdownChange="v => dropdownChange('project', v)"
        dropdownItemWordWrap
        :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.resource_type') && isShowDimensions('resource_type')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.text_73')}}</div>
      <base-select
        v-model="formData.resource_type"
        filterable
        :selectStyle="{maxWidth: '165px'}"
        :options="options.resource_type"
        @dropdownChange="v => dropdownChange('resource_type', v)"
        dropdownItemWordWrap
        :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.spec') && isShowDimensions('spec')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{ $t('bill.product_type') }}</div>
      <base-select
        v-model="formData.spec"
        filterable
        :selectStyle="{maxWidth: '165px'}"
        :options="options.spec"
        @dropdownChange="v => dropdownChange('spec', v)"
        dropdownItemWordWrap
        :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.financial_unit') && isShowDimensions('financial_unit')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{ $t('bill.financial_unit') }}</div>
      <base-select
        v-model="formData.financial_unit"
        filterable
        :selectStyle="{maxWidth: '165px'}"
        :options="options.financial_unit"
        @dropdownChange="v => dropdownChange('financial_unit', v)"
        dropdownItemWordWrap
        :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.origin_res_type') && isShowDimensions('origin_res_type')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.title.origin_res_type')}}</div>
      <base-select
        v-model="formData.origin_res_type"
        filterable
        :selectStyle="{maxWidth: '165px'}"
        :options="options.origin_res_type"
        @dropdownChange="v => dropdownChange('origin_res_type', v)"
        dropdownItemWordWrap
        :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
    </div>
  </div>
</template>

<script>
import * as R from 'ramda'
import { mapGetters, mapState } from 'vuex'
import { CHARGE_TYPES } from '@Bill/constants'
import { uuid } from '@/utils/utils'
import AnalysisesMixin from '../mixins/analysises'

export default {
  name: 'BillAnalysisFilter',
  mixins: [AnalysisesMixin],
  props: {
    formData: {
      type: Object,
    },
    showDimensions: {
      type: Array,
    },
    billType: String,
  },
  data () {
    return {
      R,
      options: {
        brand: [],
        account: [],
        linked_name: [],
        region: [],
        project: [],
        chargeType: CHARGE_TYPES,
        domain: [],
        cloudprovider_name: [],
        resource_type: [],
        spec: [],
        financial_unit: [],
        origin_res_type: [],
      },
      billTypeOpts: [
        { id: 'stat_value', name: this.$t('bill.text_125') },
        { id: 'stat_value_sec', name: this.$t('bill.converted_amount') },
      ],
    }
  },
  computed: {
    ...mapGetters(['isAdminMode', 'isDomainMode', 'scope']),
    ...mapState('common', {
      enableCostConversion: state => state.bill.globalConfig.cost_conversion_available,
    }),
    tagParams () {
      const {
        platform_brand,
        account_id,
        cloudprovider_id,
        region_ext_id,
        charge_type,
      } = this.formData
      const { start_date = '', end_date = '' } = this.formData.date
      const startDate = this.$moment(start_date.substr(0, start_date.length - 2)).format('YYYYMMDD')
      const endDate = this.$moment(end_date.substr(0, end_date.length - 2)).format('YYYYMMDD')
      return {
        platform_brand,
        account_id,
        cloudprovider_id,
        region_ext_id,
        charge_type,
        start_day: startDate,
        end_day: endDate,
      }
    },
    instanceTagParams () {
      const {
        platform_brand,
        account_id,
        cloudprovider_id,
        region_ext_id,
        charge_type,
      } = this.formData
      const { start_date, end_date } = this.formData.date
      const startDate = this.$moment(start_date.substr(0, start_date.length - 2)).format('YYYYMMDD')
      const endDate = this.$moment(end_date.substr(0, end_date.length - 2)).format('YYYYMMDD')
      return {
        platform_brand,
        account_id,
        cloudprovider_id,
        region_ext_id,
        charge_type,
        start_day: startDate,
        end_day: endDate,
        resources: 'payment_bill',
        key_prefix: ['user:', 'ext:'],
      }
    },
    projectTagParams () {
      const {
        platform_brand,
        account_id,
        cloudprovider_id,
        region_ext_id,
        charge_type,
      } = this.formData
      const { start_date = '', end_date = '' } = this.formData.date
      const startDate = this.$moment(start_date.substr(0, start_date.length - 2)).format('YYYYMMDD')
      const endDate = this.$moment(end_date.substr(0, end_date.length - 2)).format('YYYYMMDD')
      return {
        platform_brand,
        account_id,
        cloudprovider_id,
        region_ext_id,
        charge_type,
        start_day: startDate,
        end_day: endDate,
        resources: 'payment_bill',
        key_prefix: ['user:', 'ext:'],
      }
    },
  },
  watch: {
    'formData.date': {
      handler: function (val) {
        this.clearFilterOptions()
      },
    },
  },
  created () {
    this.resourceM = new this.$Manager('payment_bills', 'v1')
  },
  methods: {
    clearFilterOptions () {
      for (const field in this.options) {
        if (field !== 'chargeType' && this.options[field].length) {
          this.options[field] = []
          this.fetchDistinct(field)
        }
      }
    },
    dropdownChange (field, open) {
      if (this.options[field] && this.options[field].length) return
      if (open) {
        this.fetchDistinct(field)
      }
    },
    getDistinctParams (field) {
      const { start_date, end_date } = this.formData.date
      const ret = {
        admin: this.isAdmin,
        scope: this.scope,
        field,
        $t: uuid(),
        start_date,
        end_date,
      }
      return ret
    },
    fetchDistinct (field) {
      if (!this.resourceM) this.resourceM = new this.$Manager('payment_bills', 'v1')
      if (field === 'account') {
        this.fetchAccountDistinct()
        return
      }
      const params = this.getDistinctParams(field)
      this.resourceM.get({
        id: 'distinct-field',
        params,
      }).then(res => {
        const data = (res.data || {})[field] || []
        const ret = []
        data.filter(item => item).map(key => {
          const retItem = { id: key, name: key }
          if (field === 'brand') {
            retItem.name = this.getNameI18n(key, 'brand')
          } else if (field === 'account') {
            retItem.name = this.getNameI18n(key, 'account')
          } else if (field === 'resource_type') {
            retItem.name = this.getNameI18n(key, 'resource_type')
          }
          ret.push(retItem)
        })
        ret.sort((a, b) => {
          return a.name.localeCompare(b.name)
        })
        this.options[field] = ret
        let fField = field
        if (field === 'brand') {
          fField = 'platform_brand'
        }
        if (field === 'cloudprovider_name') {
          fField = 'cloudprovider'
        }
        if (this.formData[fField] && this.formData[fField].length) {
          this.formData[fField] = this.formData[fField].filter(id => ret.some(item => item.id === id))
        }
      }).catch(err => {
        console.error(err)
      })
    },
    fetchAccountDistinct () {
      new this.$Manager('meter_cloudaccounts', 'v1').get({
        id: 'distinct-accounts',
      }).then(res => {
        const { data = [] } = res.data || {}
        const ret = []
        data.filter(item => item.name).map(item => {
          const retItem = { id: item.name, name: this.getNameI18n(item.name, 'account') }
          if (item.description) retItem.name = `${item.name}(${item.description})`
          ret.push(retItem)
        })
        ret.sort((a, b) => {
          return a.name.localeCompare(b.name)
        })
        this.options.account = ret
        if (this.formData.account && this.formData.account.length) {
          this.formData.account = this.formData.account.filter(id => ret.some(item => item.id === id))
        }
      }).catch(err => {
        console.error(err)
      })
    },
    uniqueArr (arr, byId = 'item_id') {
      const obj = {}
      arr.forEach(val => {
        obj[val[byId]] = val
      })
      return Object.values(obj)
    },
    isShowDimensions (v) {
      if (this.showDimensions && this.showDimensions.length > 0) {
        return this.showDimensions.includes(v)
      }
      return true
    },
    billTypeChange (val) {
      const next = Array.isArray(val) ? val.filter(Boolean) : (val ? [val] : [])
      if (!next.length) {
        this.$message.warning(this.$t('bill.bill_type_required'))
        return
      }
      this.$emit('billTypeChange', next)
    },
  },
}
</script>
<style lang="less" scoped>
.tag-list {
  margin-top: 10px;
  .tag {
    max-width: 100%;
    line-height: 20px;
    margin-right: 10px;
    padding: 0 18px 0 4px;
    font-size: 12px;
    border-style: solid;
    border-width: 1px;
    margin-bottom: 10px;
    position: relative;
  }
}
</style>
